/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-19 10:31:23
 * @LastEditTime: 2019-09-19 17:57:43
 * @LastEditors: Please set LastEditors
 */
// import {api} from '../../utils/api'

export default {
  state: {
    uid: 0,
    userInfo: {},
    aesid: 0,
    session: '',
    guid: '',
    version: '',
    wxUserInfo: {}
  },
  getters: {
    uid: state => {
      return state.uid// 用户的encrypt
    },
    guid: state => {
      return state.guid
    },
    version: state => {
      return state.version
    },
    session: state => {
      return state.session
    },
    userInfo: state => {
      return state.userInfo
    },
    wxUserInfo: state => {
      return state.wxUserInfo
    }
  },
  mutations: {
    loginIn (state, uid) {
      state.uid = uid
    },
    setUserInfo (state, info, flg) {
      state.userInfo = info
    },
    setUserVersion (state, version, flg) {
      state.version = version
    },
    setBaseInfo (state, info) {
      state.uid = info.uid
      state.version = info.version
      state.session = info.session
      state.guid = info.guid
      state.userInfo = info
    },
    setWxUserInfo (state, info, flg) {
      state.wxUserInfo = info
    },
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js